<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Bell" class="d-icon d-icon--bell" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M4.884 10.068a.5.5 0 0 1 .684.181.5.5 0 0 0 .865 0 .5.5 0 0 1 .865.502 1.5 1.5 0 0 1-2.595 0 .5.5 0 0 1 .181-.683ZM6 .5A3.5 3.5 0 0 0 2.5 4c0 1.676-.359 2.717-.689 3.323a2.968 2.968 0 0 1-.44.622 1.51 1.51 0 0 1-.153.142h-.001a.515.515 0 0 0-.16.18.498.498 0 0 0-.033.387A.5.5 0 0 0 1.5 9h9a.5.5 0 0 0 .283-.912l-.001-.001a1.507 1.507 0 0 1-.153-.142 2.97 2.97 0 0 1-.44-.622C9.859 6.717 9.5 5.676 9.5 4A3.5 3.5 0 0 0 6 .5Zm0 1A2.5 2.5 0 0 0 3.5 4c0 1.824-.391 3.033-.811 3.802-.038.07-.076.136-.114.198h6.85a4.705 4.705 0 0 1-.114-.198C8.891 7.032 8.5 5.824 8.5 4A2.5 2.5 0 0 0 6 1.5ZM1.057 8.268Zm9.886 0a.504.504 0 0 0-.161-.181h.001c.07.049.124.111.16.182Z" fill="currentColor"/></svg>
</template>

<script>
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconBell',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
  },
};
</script>
